import { memo } from 'react'

export default memo(({ children, condition }) =>
  condition ? children[0] : children[1],
)
